/**
 * Preserve vendor-scraped copy before AI overwrites catalog fields.
 */

function asStringArray(v: unknown): string[] {
  if (v == null) return [];
  if (Array.isArray(v)) return v.map((x) => (x == null ? '' : String(x))).filter(Boolean);
  if (typeof v === 'string') return v.trim() ? [v.trim()] : [];
  return [];
}

function featuresKey(list: string[]): string {
  return list.map((s) => s.trim()).filter(Boolean).join('\n');
}

export interface ScrapedBackupProduct {
  description?: string | null;
  shortDescription?: string | null;
  features?: unknown;
  scrapedDescription?: string | null;
  scrapedShortDescription?: string | null;
  scrapedFeatures?: unknown;
}

/** Copy current catalog values into scraped* when those backups are still empty. */
export function snapshotScrapedFieldsIfNeeded(
  product: ScrapedBackupProduct,
  patch: Record<string, unknown>,
): Record<string, unknown> {
  const out = { ...patch };

  if (patch.description !== undefined) {
    const current = String(product.description || '').trim();
    const next = String(patch.description ?? '').trim();
    const existing = String(product.scrapedDescription || '').trim();
    if (!existing && current && current !== next) {
      out.scrapedDescription = current;
    }
  }

  if (patch.shortDescription !== undefined) {
    const current = String(product.shortDescription || '').trim();
    const next = String(patch.shortDescription ?? '').trim();
    const existing = String(product.scrapedShortDescription || '').trim();
    if (!existing && current && current !== next) {
      out.scrapedShortDescription = current;
    }
  }

  if (patch.features !== undefined) {
    const current = asStringArray(product.features);
    const next = asStringArray(patch.features);
    const existing = asStringArray(product.scrapedFeatures);
    if (existing.length === 0 && current.length > 0 && featuresKey(current) !== featuresKey(next)) {
      out.scrapedFeatures = [...current];
    }
  }

  return out;
}
